import * as core from '../../../../../../../core'
import * as changeImpacts from '../change-impacts'

export const RESOURCE = {
  payload: {
    alias: 'details',
    appAlias: changeImpacts.RESOURCE.payload.alias,
    description: 'See and edit details of a change impact',
    display: {
      isMain: false,
      position: 0,
    },
    name: 'Details',
    page: { alias: 'details' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
